import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { AlertCircle, Refresh } from "mdi-material-ui";
import { createContext, useContext, useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { Card, CardActions, useTrack } from "./index.js";
const ErrorContext = createContext({
    addError: () => { },
});
const ErrorFallback = ({ error }) => {
    const { t } = useTranslation("ErrorFallback");
    useEffect(() => {
        const now = Date.now();
        const lastReloaded = Number.parseInt(localStorage.getItem("error-fallback-auto-reload") || "0");
        const shouldReload = lastReloaded + 60 * 1000 < now;
        if (location.pathname.startsWith("/lobby") && !shouldReload) {
            location.reload();
            localStorage.setItem("error-fallback-auto-reload", now.toString());
        }
    }, []);
    return (_jsx(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
        }, children: _jsxs(Box, { sx: { pb: 24 }, children: [_jsxs(Card, { icon: _jsx(AlertCircle, {}), title: t("title"), children: [t("message"), error instanceof Error && (_jsxs(Box, { sx: {
                                fontFamily: "monospace",
                                fontSize: 12,
                                mx: -1,
                                mt: 1,
                                mb: -1,
                                p: 1,
                                borderRadius: 1,
                                backgroundColor: ({ palette }) => palette.error.dark,
                                color: "white",
                            }, children: [_jsx("div", { children: error.name }), _jsx("div", { children: error.message })] }))] }), _jsx(CardActions, { children: _jsx(Button, { variant: "contained", startIcon: _jsx(Refresh, {}), onClick: () => location.reload(), children: t("action") }) })] }) }));
};
export const ErrorProvider = ({ children }) => {
    const { t } = useTranslation("ErrorProvider");
    const [errors, setErrors] = useState([]);
    const addError = (err, action, content) => {
        setErrors([...errors, { err, action, content }]);
    };
    const { posthog } = useTrack();
    return (_jsx(ErrorBoundary, { FallbackComponent: ErrorFallback, onError: (error) => posthog?.capture("$exception", error), children: _jsxs(ErrorContext.Provider, { value: { addError }, children: [children, errors.map(({ err, content, action }, index) => (_jsxs(Dialog, { open: true, children: [_jsx(DialogTitle, { children: t("title") }), content || (
                        // @ts-ignore
                        _jsx(DialogContent, { children: t(err.message) })), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: () => {
                                        const newErrors = errors.slice();
                                        newErrors.splice(index, 1);
                                        setErrors(newErrors);
                                    }, children: t("close") }), action] })] }, `error-${index.toString()}`)))] }) }));
};
export const useError = () => useContext(ErrorContext);
//# sourceMappingURL=ErrorProvider.js.map